<template>
  <div class="tc-login-page">
    <div class="container h-100">
      <div class="row h-100 justify-content-center align-items-center">
        <div class="col-md-6 col-lg-5">
          <div class="tc-login-glass-card p-5">
            <div class="text-center mb-4">
              <h2 class="fw-bold tc-login-text-gradient mb-2">Welcome Back</h2>
              <p class="text-muted">Log in to the Time Change platform</p>
            </div>
            <Login />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Login from '@lib/frontend/components/Login.vue'
export default {
  components: { Login }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap');

.tc-login-page {
  font-family: 'Outfit', sans-serif;
  min-height: 100vh;
  background-color: #F8F9FC;
  background-image: radial-gradient(circle at 10% 20%, rgba(108, 93, 211, 0.05) 0%, transparent 20%),
                    radial-gradient(circle at 90% 80%, rgba(108, 93, 211, 0.05) 0%, transparent 20%);
}

.tc-login-glass-card {
  background: #ffffff;
  border: 1px solid #E2E2EA;
  border-radius: 24px;
  box-shadow: 0 15px 35px rgba(0,0,0,0.05);
}

.tc-login-text-gradient {
  background: linear-gradient(135deg, #6C5DD3, #8a7df0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>